// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 29/11/2023
 */

 .PaymentForm_stripeElement__AoPwb {
  display: block;
  padding: 10px 12px;
  margin: 10px 0;
  font-size: 1rem;
  font-family: 'Arial', sans-serif;
  border: 1px solid #ccc;
  border-radius: 0.5rem;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  background-color: white;
}

/* Customize the invalid input styles */
.PaymentForm_stripeElement--invalid__FXVJQ {
  border-color: #dc3545;
}

/* Customize the focus state styles */
.PaymentForm_stripeElement--focus__dmrf5 {
  box-shadow: 0 0 3px 2px rgba(50, 140, 255, 0.5);
  border-color: #327eff;
  outline: none;
}

/* Customize the transition duration for smoother animations */
.PaymentForm_transition__yx5Xk {
  transition: box-shadow 150ms ease-out, border-color 150ms ease-out;
}

.PaymentForm_button__cFwyS {
  display: block;
  margin-left: 3rem;
  border-radius: 0.5rem;
  margin: 10px 0;
  height: 3rem;
  font-size: 1rem;
  font-weight: 500;
}

.PaymentForm_buttonProgress__AiTXY {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -12px;
  margin-left: -12px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Checkout/PaymentForm.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;CAED;EACC,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,sBAAsB;EACtB,qBAAqB;EACrB,gDAAgD;EAChD,uBAAuB;AACzB;;AAEA,uCAAuC;AACvC;EACE,qBAAqB;AACvB;;AAEA,qCAAqC;AACrC;EACE,+CAA+C;EAC/C,qBAAqB;EACrB,aAAa;AACf;;AAEA,8DAA8D;AAC9D;EACE,kEAAkE;AACpE;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 29/11/2023\r\n */\r\n\r\n .stripeElement {\r\n  display: block;\r\n  padding: 10px 12px;\r\n  margin: 10px 0;\r\n  font-size: 1rem;\r\n  font-family: 'Arial', sans-serif;\r\n  border: 1px solid #ccc;\r\n  border-radius: 0.5rem;\r\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\r\n  background-color: white;\r\n}\r\n\r\n/* Customize the invalid input styles */\r\n.stripeElement--invalid {\r\n  border-color: #dc3545;\r\n}\r\n\r\n/* Customize the focus state styles */\r\n.stripeElement--focus {\r\n  box-shadow: 0 0 3px 2px rgba(50, 140, 255, 0.5);\r\n  border-color: #327eff;\r\n  outline: none;\r\n}\r\n\r\n/* Customize the transition duration for smoother animations */\r\n.transition {\r\n  transition: box-shadow 150ms ease-out, border-color 150ms ease-out;\r\n}\r\n\r\n.button {\r\n  display: block;\r\n  margin-left: 3rem;\r\n  border-radius: 0.5rem;\r\n  margin: 10px 0;\r\n  height: 3rem;\r\n  font-size: 1rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.buttonProgress {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  margin-top: -12px;\r\n  margin-left: -12px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stripeElement": `PaymentForm_stripeElement__AoPwb`,
	"stripeElement--invalid": `PaymentForm_stripeElement--invalid__FXVJQ`,
	"stripeElement--focus": `PaymentForm_stripeElement--focus__dmrf5`,
	"transition": `PaymentForm_transition__yx5Xk`,
	"button": `PaymentForm_button__cFwyS`,
	"buttonProgress": `PaymentForm_buttonProgress__AiTXY`
};
export default ___CSS_LOADER_EXPORT___;
